import { render, staticRenderFns } from "./CurrentEarnings.vue?vue&type=template&id=68a7a5b0&scoped=true"
import script from "./CurrentEarnings.vue?vue&type=script&lang=js"
export * from "./CurrentEarnings.vue?vue&type=script&lang=js"
import style0 from "./CurrentEarnings.vue?vue&type=style&index=0&id=68a7a5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7a5b0",
  null
  
)

export default component.exports